import is from '@sindresorhus/is';

import type { LanguageCodeForJSA } from '~/shared/internationalization';

import { useJobItemDetails } from '../api/use-job-item-details';
import { useSetupLanguage } from '../hooks/use-language';
import type { JsaProfileDetailTilePayload } from '../url-tile-payloads';

export const useJobProfileTileLanguage = (
    payload: JsaProfileDetailTilePayload,
): {
    readonly activeLanguage: LanguageCodeForJSA;
    readonly availableLanguages: readonly { readonly id: LanguageCodeForJSA; readonly name: string }[];
} => {
    const { data: item } = useJobItemDetails({
        architectureId: payload.architectureId,
        itemId: payload.profileId,
        itemType: payload.itemType,
        version: is.number(payload.version) ? payload.version.toString() : undefined,
    });

    const { activeLanguage, availableLanguages } = useSetupLanguage(payload.preferredLanguage, item?.jobProfile);

    return { activeLanguage, availableLanguages };
};
